import { defineStore, acceptHMRUpdate } from 'pinia';
import { storeConfig } from '@/shared/storeConfig';

const authSocialStore = () => {
  const socialEmail = ref<string>('');
  const socialToken = ref<string>('');
  const socialService = ref<string>('');
  const isSocialAuthFlow = ref<boolean>(false);

  const setAuthSocialData = (data: {
    email: string;
    token: string;
    service: string;
  }) => {
    if (!data.email || !data.token || !data.service) {
      return;
    }

    socialEmail.value = data.email;
    socialToken.value = data.token;
    socialService.value = data.service;
    isSocialAuthFlow.value = true;
  };

  const clearAuthSocialData = () => {
    socialEmail.value = '';
    socialToken.value = '';
    socialService.value = '';
    isSocialAuthFlow.value = false;
  };

  return {
    socialEmail,
    socialToken,
    socialService,
    isSocialAuthFlow,
    setAuthSocialData,
    clearAuthSocialData,
  };
};

export const useAuthSocialStore = defineStore(
  'authSocial',
  authSocialStore,
  storeConfig,
);

// @ts-ignore
if (import.meta.hot) {
  // @ts-ignore
  import.meta.hot.accept(acceptHMRUpdate(useAuthSocialStore, import.meta.hot));
}
